import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as artifactActions from '~/artifact/actions';
import Helpers from '~/utils/Helpers';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerMaven from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerMaven';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerGradle from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerGradle';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerSBT from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerSBT';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerRubyGems from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerRubyGems';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerNPM from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerNPM';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerBower from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerBower';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerPyPI from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerPyPI';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerGlide from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerGlide';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerGoVendor from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerGoVendor';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerTrash from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerTrash';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerGoDep from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerGoDep';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerGoGet from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerGoGet';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerPackagist from '~/artifact/components/ArtifactViewMainContentFixInfoHowToFixPackageManagerPackagist';
import ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader from '~/artifact/containers/ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader';
import { vulnerabilityRangeTypesMap, SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
import DOMPurify from 'dompurify';

type ArtifactViewMainContentFixInfoHowToFixTransitiveProps = {
  actions: object;
  artifactState: object;
  component: object;
  range: object;
};
class ArtifactViewMainContentFixInfoHowToFixTransitive extends React.Component<
  ArtifactViewMainContentFixInfoHowToFixTransitiveProps,
  {}
> {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount() {
    let component = this.props.component || {},
      coordinateType = component.coordinateType || '',
      range = this.props.range,
      fixText = range.fixText || '';
    const packageManager = coordinateType === 'GO' ? 'glide' : coordinateType;
    this.props.actions.updateComponentPackageManager(packageManager);
    this.props.actions.fetchMarkdownHtml('fixTextTransitive', fixText);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    let oldComponent = this.props.component || {},
      newComponent = nextProps.component || {},
      coordinateType = newComponent.coordinateType || '';
    if (oldComponent.id !== newComponent.id && coordinateType) {
      const packageManager = coordinateType === 'GO' ? 'glide' : coordinateType;
      this.props.actions.updateComponentPackageManager(packageManager);
    }
    if (this.props.range.id !== nextProps.range.id) {
      this.props.actions.fetchMarkdownHtml('fixTextTransitive', nextProps.range.fixText);
    }
  }
  formatCode(code) {
    return <span className="font-family--code bg-color--white-medium p---">{code}</span>;
  }
  render() {
    let range = this.props.range,
      store = this.props.artifactState,
      activeVulnRangeTab = store.activeVulnRangeTab,
      safeCommitHash = store.activeSafeCommitHash,
      safeVersion = store.activeSafeVersion,
      safeVersions = store.safeVersionsAfterRange || [],
      component = this.props.component || {},
      currentComponentId = store.componentId,
      currentVersionRange = store.vulnerableRangeByComponent[currentComponentId] || {},
      fixVersion = range.updateToVersion || '',
      fixText = currentVersionRange.fixText,
      languageType = component.languageType || '',
      language = languageType.toLowerCase(),
      coordinateType = component.coordinateType || '',
      activeManager = store.componentPackageManager,
      packageManagerHeaders = [],
      packageManagerDiffElementLookup = {
        maven: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerMaven
            component={component}
            range={range}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        gradle: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerGradle
            component={component}
            range={range}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        sbt: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerSBT
            component={component}
            range={range}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        gem: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerRubyGems
            component={component}
            range={range}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        npm: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerNPM
            component={component}
            range={range}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        bower: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerBower
            component={component}
            range={range}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        pypi: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerPyPI
            component={component}
            range={range}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        glide: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerGlide
            component={component}
            range={range}
            safeCommitHash={safeCommitHash}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        govendor: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerGoVendor
            component={component}
            range={range}
            safeCommitHash={safeCommitHash}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        trash: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerTrash
            component={component}
            range={range}
            safeCommitHash={safeCommitHash}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        godep: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerGoDep
            component={component}
            range={range}
            safeCommitHash={safeCommitHash}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        goget: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerGoGet
            component={component}
            range={range}
            safeCommitHash={safeCommitHash}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
        packagist: (
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerPackagist
            component={component}
            range={range}
            safeVersion={safeVersion}
            transitive={true}
          />
        ),
      },
      maybePackageManagerDiffElement,
      updateText = <div />,
      validateText = <div />,
      fixInSafeVersions = false,
      showPackageManagers = false,
      packageManagerHtml,
      markdownHtml = store.markdownHtml,
      fixTextHtml = markdownHtml.fixTextTransitive || '',
      fixTextContent = (
        <div
          className="markdown--artifact"
          //eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fixTextHtml) }}
        />
      ),
      fixLinks = range.fixLinks,
      linkElements = [],
      fixLinkHtml = <div />;
    const hasSafeVersion = safeVersions.length > 0 || !!safeCommitHash;
    const commitHashOrVersionText = Helpers.isCommitHash(fixVersion) ? 'commit' : 'version';
    coordinateType = coordinateType.toLowerCase();
    fixLinks = _.filter(fixLinks, fix => fix.link && fix.description);
    fixLinks.forEach(link => {
      linkElements.push(
        <div className="grid pt-">
          <div className="grid__item col-1-1">
            {link.type.toLowerCase()}:{' '}
            <a href={link.link} className="link--primary" target="_blank">
              {link.description}
            </a>
          </div>
        </div>
      );
    });
    if (fixLinks.length > 0) {
      fixLinkHtml = (
        <div>
          <div className="grid__item col-1-1 pt">More references:</div>
          <div className="grid__item col-1-1">{linkElements}</div>
        </div>
      );
    }
    if (safeVersions && fixVersion) {
      if (_.findIndex(safeVersions, { version: fixVersion }) >= 0) {
        fixInSafeVersions = true;
      }
    }
    // Fix version is present and at least a safe version is present. Fix version not in safe version
    if (fixVersion && hasSafeVersion && !fixInSafeVersions) {
      updateText = (
        <div>
          <p className="pt-">
            <strong>Add</strong>
          </p>
          <p>
            This issue was fixed in {commitHashOrVersionText} {this.formatCode(fixVersion)}..
            However, that version is itself subject to{' '}
            <Link
              className="link--obvious"
              to={`/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/components/${
                component.id
              }`}
            >
              other vulnerabilities
            </Link>
            , we suggest that you{' '}
            {safeCommitHash ? (
              <span>
                use{' '}
                <span className="font-family--code bg-color--white-medium p---">
                  {safeCommitHash}
                </span>{' '}
                which does not have any vulnerabilities.
              </span>
            ) : (
              'upgrade to one of the safe versions on the left.'
            )}
          </p>
        </div>
      );
      validateText = (
        <div>
          <p className="pt-">
            <strong>Validate</strong>
          </p>
          <p>
            Applying the fix may break your project, we recommend that you always build and test
            your project to verify that the fix has been successful.
          </p>
        </div>
      );
      showPackageManagers = true;
    } else if (fixVersion && hasSafeVersion && fixInSafeVersions) {
      // Fix version is present and at least a safe version is present and fix version is in safe versions
      updateText = (
        <div>
          <p className="pt-">
            <strong>Update</strong>
          </p>
          <p>
            This issue was fixed in version {this.formatCode(fixVersion)}. That version is currently
            considered safe, we suggest that you upgrade to the fixed version.
          </p>
        </div>
      );
      validateText = (
        <div>
          <p className="pt-">
            <strong>Validate</strong>
          </p>
          <p>
            Applying the fix may break your project, we recommend that you always build and test
            your project to verify that the fix has been successful.
          </p>
        </div>
      );
      showPackageManagers = true;
    } else if (fixVersion && !hasSafeVersion) {
      // Fix version is present but no safe version. Do not show the Maven/Gradle/sbt section on the right.
      updateText = (
        <div>
          <p className="pt-">
            <strong>Update</strong>
          </p>
          <p>
            This issue was fixed in version {this.formatCode(fixVersion)}. However, that version is
            itself subject to{' '}
            <Link
              className="link--obvious"
              to={`/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/components/${
                component.id
              }`}
            >
              other vulnerabilities
            </Link>
            , there are no safe versions to upgrade to.
          </p>
        </div>
      );
      validateText = <div />;
      showPackageManagers = false;
    } else if (!fixVersion && hasSafeVersion) {
      // Fix versions is missing but there is at least a safe version
      updateText = (
        <div>
          <p className="pt-">
            <strong>Update</strong>
          </p>
          <p>
            We do not have a confirmed fix for this issue yet.{' '}
            {safeCommitHash ? (
              <span>
                You may use{' '}
                <span className="font-family--code bg-color--white-medium p---">
                  {safeCommitHash}
                </span>{' '}
                which does not have any vulnerabilities.
              </span>
            ) : (
              'However, newer versions of the library have been released, we suggest that you upgrade to one of the safe versions on the left.'
            )}
          </p>
        </div>
      );
      validateText = (
        <div>
          <p className="pt-">
            <strong>Validate</strong>
          </p>
          <p>
            Applying the fix may break your project, we recommend that you always build and test
            your project to verify that the fix has been successful.
          </p>
        </div>
      );
      showPackageManagers = true;
    } else if (!fixVersion && safeVersions.length == 0 && fixText) {
      // Fix version is missing (and there is no safe version) but Fix text is present: Do not show the Maven/Gradle/sbt section on the right.
      updateText = (
        <div>
          <p className="pt-">
            <strong>Add</strong>
          </p>
          <p>
            This issue has not yet been fixed in a released version of the library. Please use the
            following steps to mitigate the issue:
          </p>
          {fixTextContent}
          {fixLinkHtml}
        </div>
      );
      validateText = (
        <div>
          <p className="pt-">
            <strong>Validate</strong>
          </p>
          <p>
            Applying the fix may break your project, we recommend that you always build and test
            your project to verify that the fix has been successful.
          </p>
        </div>
      );
      showPackageManagers = false;
    } else {
      // Safe/Fix version and Fix text both are missing:
      updateText = (
        <div>
          <p className="pt-">
            <strong>Update</strong>
          </p>
          <p>
            This issue has not yet been fixed in a released version of the library. Moreover, there
            are no known mitigation steps.
          </p>
        </div>
      );
      validateText = <div />;
      showPackageManagers = false;
    }
    maybePackageManagerDiffElement = packageManagerDiffElementLookup[activeManager];
    if ((language === 'js' || language === 'javascript') && coordinateType === 'npm') {
      packageManagerHeaders.push(
        <div key="npm" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="npm / Yarn"
            section="npm"
            activeSection={activeManager}
          />
        </div>
      );
    } else if ((language === 'js' || language === 'javascript') && coordinateType === 'bower') {
      packageManagerHeaders.push(
        <div key="bower" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="bower"
            section="bower"
            activeSection={activeManager}
          />
        </div>
      );
    } else if (language === 'ruby') {
      packageManagerHeaders.push(
        <div key="gem" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="Ruby Gems"
            section="gem"
            activeSection={activeManager}
          />
        </div>
      );
    } else if (language === 'python') {
      packageManagerHeaders.push(
        <div key="pypi" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="PyPI"
            section="pypi"
            activeSection={activeManager}
          />
        </div>
      );
    } else if (language === 'java') {
      packageManagerHeaders.push(
        <div key="maven" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="Maven"
            section="maven"
            activeSection={activeManager}
          />
        </div>
      );
      packageManagerHeaders.push(
        <div key="gradle" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="Gradle"
            section="gradle"
            activeSection={activeManager}
          />
        </div>
      );
      packageManagerHeaders.push(
        <div key="sbt" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="sbt"
            section="sbt"
            activeSection={activeManager}
          />
        </div>
      );
    } else if (language === 'go') {
      packageManagerHeaders.push(
        <div key="glide" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="Glide"
            section="glide"
            activeSection={activeManager}
          />
        </div>
      );
      packageManagerHeaders.push(
        <div key="govendor" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="GoVendor"
            section="govendor"
            activeSection={activeManager}
          />
        </div>
      );
      packageManagerHeaders.push(
        <div key="trash" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="Trash"
            section="trash"
            activeSection={activeManager}
          />
        </div>
      );
      if (activeVulnRangeTab === vulnerabilityRangeTypesMap.COMMIT_HASHES) {
        packageManagerHeaders.push(
          <div key="godep" className="inline-block">
            <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
              text="GoDep"
              section="godep"
              activeSection={activeManager}
            />
          </div>
        );
        packageManagerHeaders.push(
          <div key="goget" className="inline-block">
            <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
              text="go get"
              section="goget"
              activeSection={activeManager}
            />
          </div>
        );
      }
    } else if (language === 'php') {
      packageManagerHeaders.push(
        <div key="php" className="inline-block">
          <ArtifactViewMainContentFixInfoHowToFixPackageManagerHeader
            text="Composer"
            section="packagist"
            activeSection={activeManager}
          />
        </div>
      );
    }
    if (showPackageManagers) {
      packageManagerHtml = (
        <div className="grid__item col-1-1 mt pt ">
          <div className="bo-t--1 border-color--white-dark pt">
            <div className={'ph flex flex--justify-content--space-between phone--col-1-1 col-1-2'}>
              {packageManagerHeaders}
            </div>
            <div className="grid__item col-1-1 pb+">{maybePackageManagerDiffElement}</div>
          </div>
        </div>
      );
    } else {
      packageManagerHtml = <div />;
    }
    return (
      <div className="grid">
        <div className="grid__item col-1-1 pr+">
          A transitive dependency is a library that is included in your project indirectly through
          another dependency. A vulnerability in a transitive dependency can be fixed by adding a
          new direct dependency of the library in your project. Adding a new dependency in your
          project may break it or lead to unexpected results, we always recommend you rebuild and
          test your project.
          {updateText}
          {validateText}
        </div>
        {packageManagerHtml}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    routing: state.routing,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentFixInfoHowToFixTransitive);
